import { useMemo } from 'react';
import useSWR, { SWRConfiguration } from 'swr';
import { CustomFieldOptionType } from '../../components/CustomField/CustomField.type';
import { DEDUP_INTERVAL_AUTOCOMPLETE } from '../../constants/swr-config';
import { customSWRResponse } from '../../model/types';
import endPoints from '../../services/endpoints';
import { fetcherWithTokenWithParams } from '../../utils/fetchers';
import { localizedSearchTermForApi, nonNullishValue } from '../../utils/helpers';
import { AutocompleteResponseType } from '../autocomplete/useAutocompleteSuggestions';
import useSWRCacheKeys from '../useSWRCacheKeys';

export default function useTagSearch(
    searchTerm: string,
    config: SWRConfiguration = {}
): customSWRResponse<Omit<CustomFieldOptionType, 'order'>[]> {
    const keys = useSWRCacheKeys(endPoints.autoComplete.tagSearch);

    const isAbleToMakeRequest = nonNullishValue(searchTerm) && searchTerm?.length > 0 && nonNullishValue(keys);

    const { data, error, isValidating } = useSWR<AutocompleteResponseType<string>>(
        isAbleToMakeRequest ? [localizedSearchTermForApi(searchTerm), ...keys] : null,
        fetcherWithTokenWithParams,
        { dedupingInterval: DEDUP_INTERVAL_AUTOCOMPLETE, ...config }
    );

    const searchResultAsOptions = useMemo(() => {
        return data?.result?.map((tag) => ({ label: tag, value: tag }));
    }, [data]);

    return {
        data: searchResultAsOptions,
        error,
        isLoading: isValidating
    };
}
// TODO: add suggestions
